import UserBasicInfoSettings from './UserBasicInfoSettings'

export default UserBasicInfoSettings
